import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Truck, RotateCcw, ShieldCheck, Gift } from 'lucide-react';
import './HomeRetail.css';

export const PromoStrip = () => (
  <div className="promo-strip">
    <div className="promo-strip-inner">
      <p>
        <strong>Deals List members:</strong> get early access to flash markdowns + free shipping over $75.
      </p>
      <Link to="/rewards">
        Join free <ArrowRight size={15} />
      </Link>
    </div>
  </div>
);

export const ClearanceBanner = () => (
  <section className="clearance-banner" aria-label="Clearance">
    <div className="clearance-banner-inner">
      <div>
        <p className="clearance-eyebrow">Limited time</p>
        <h2>Clearance up to 60% off</h2>
        <p className="clearance-sub">Final markdowns on select women, men &amp; home — while supplies last.</p>
      </div>
      <Link to="/sale" className="clearance-cta">
        Shop clearance <ArrowRight size={18} />
      </Link>
    </div>
  </section>
);

export const TrustBar = () => {
  const items = [
    { Icon: Truck, title: 'Free shipping $75+', text: 'On eligible U.S. orders' },
    { Icon: RotateCcw, title: '30-day returns', text: 'Easy online returns' },
    { Icon: ShieldCheck, title: 'Secure checkout', text: 'Encrypted payments' },
    { Icon: Gift, title: 'Deals List perks', text: 'Early drops & offers' },
  ];

  return (
    <section className="trust-bar" aria-label="Why shop with us">
      <div className="trust-bar-inner">
        {items.map(({ Icon, title, text }) => (
          <div key={title} className="trust-item">
            <span className="trust-icon"><Icon size={22} strokeWidth={2} /></span>
            <div>
              <strong>{title}</strong>
              <p>{text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PromoStrip;
